import { Component, OnInit, inject } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {Client} from '../../../client/client';
import {ClientService} from '../../../client/client.service';
import {map, mergeMap} from 'rxjs/operators';
import {Location} from '@angular/common';
import {ClientMeldingService} from '../../../client-melding/client-melding.service';
import {NotificationService} from '../../../core/notification/notification.service';

@Component({
    templateUrl: './client-fiche.page.html',
    styleUrls: ['./client-fiche.page.scss'],
    standalone: false
})
export class ClientFichePage implements OnInit {
  private clientService = inject(ClientService);
  private clientMeldingService = inject(ClientMeldingService);
  private notificationService = inject(NotificationService);
  private route = inject(ActivatedRoute);
  private location = inject(Location);

  client$: Observable<Client>;

  ngOnInit(): void {
    this.client$ = this.route.paramMap
      .pipe(
        map(paramMap => paramMap.get('id')),
        mergeMap(id => this.clientService.getClientById$(id)),
      );
  }

  onClientMeldingAdded(client: Client, content: string) {
    const dienstId = this.getDienstId();
    this.clientMeldingService
      .postClientMelding$(client.getId(), content, dienstId)
      .subscribe(_ => {
        this.notificationService.showSuccess(`Bedankt voor de melding. <br>Jouw dienst wordt op de hoogte gebracht.`)
      });
  }

  navigateBack(): void {
    this.location.back();
  }

  private getDienstId(): string | null {
    return this.route.snapshot.queryParamMap.get('dienstId');
  }
}
